import { Info, AlertTriangle } from "lucide-react";

export default function Disclaimer() {
  return (
    <div className="bg-[#fafaf9] min-h-screen" data-testid="disclaimer-page">
      <section className="bg-[#09090b] text-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-24">
          <div className="inline-flex items-center gap-2 border border-[#fb923c]/40 bg-[#ea580c]/10 text-[#fb923c] px-3 py-1.5 text-xs font-bold tracking-[0.2em] uppercase mb-6">
            <AlertTriangle className="w-3.5 h-3.5" /> Disclaimer
          </div>
          <h1 className="font-display text-4xl md:text-5xl font-black leading-tight" data-testid="disclaimer-title">
            Read this <span className="text-[#fb923c]">before</span> relying on any content here.
          </h1>
        </div>
      </section>

      <section className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-16 space-y-6 text-[#3f3f46] text-base md:text-lg leading-relaxed">
        <div className="bg-white border-l-4 border-[#ea580c] p-5 flex gap-3 items-start">
          <Info className="w-5 h-5 text-[#ea580c] mt-1 shrink-0" />
          <p><strong>Educational &amp; informational purpose only.</strong> All content is provided as-is.</p>
        </div>
        <p>
          The content provided on this website is for educational and informational purposes only. We make every effort to provide accurate and reliable information; however, we do not guarantee its completeness or accuracy.
        </p>
        <p>
          Users are advised to use the information at their own discretion. We are not responsible for any loss, damage, or consequences arising from the use of this website or reliance on its content.
        </p>
        <p className="font-semibold text-[#09090b] text-lg">
          Stay informed, use wisely, and make decisions responsibly.
        </p>
      </section>
    </div>
  );
}
